import { render, staticRenderFns } from "./studentDorm.vue?vue&type=template&id=6876ace6&scoped=true"
import script from "./studentDorm.vue?vue&type=script&lang=js"
export * from "./studentDorm.vue?vue&type=script&lang=js"
import style0 from "./studentDorm.vue?vue&type=style&index=0&id=6876ace6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876ace6",
  null
  
)

export default component.exports